import React, { useEffect, useState } from 'react';
import { kbCurationAPI } from '../../services/api';

export default function CurationStatsBar({ refreshKey }) {
  const [stats, setStats] = useState([]);
  useEffect(() => { kbCurationAPI.stats().then(r => setStats(r.data || [])).catch(()=>setStats([])); }, [refreshKey]);
  const get = (tipo, status) => stats.find(s => s.tipo===tipo && s.status===status)?.n || 0;
  return (
    <div className="flex gap-4 text-sm text-gray-600 mb-3">
      <span>Plantillas pend: <b>{get('plantilla','pending')}</b></span>
      <span>Q-R pend: <b>{get('qa_pair','pending')}</b></span>
      <span>Aprobadas: <b>{get('plantilla','approved') + get('qa_pair','approved')}</b></span>
      <span>Descartadas: <b>{get('plantilla','rejected') + get('qa_pair','rejected')}</b></span>
    </div>
  );
}
